import React from "react"
import { Layout } from "./src/common/components"

export const wrapPageElement = ({ element, props }) => (
  <Layout {...props}>{element}</Layout>
)
